import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * ScrollToTop — her sayfa navigasyonunda sayfayı en üste kaydırır.
 * SADECE ileri veya yeni sayfa açılışlarında (PUSH, REPLACE) çalışır.
 * Geri tuşuna (POP) basıldığında çalışmaz, böylece tarayıcının native scroll pozisyonu korunur.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    // "POP" = Geri veya İleri tuşuna basıldı demek.
    // Geri tuşunda sayfanın en üstüne atlamayı engelliyoruz ki kaldığı yerden devam etsin.
    if (navType !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    }
  }, [pathname, navType]);

  return null;
};

export default ScrollToTop;
